const e = typeof document != "undefined" && typeof window != "undefined";
export {
  e as isBrowser
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/env/is-browser.js
// module id = 167
// module chunks = 41